import { createMuiTheme } from '@material-ui/core/styles';
import roboto from './fonts/Roboto-Regular.ttf';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00239C',
    },
    secondary: {
      main: '#757575',
    },
    success: {
      main: '#4caf50',
      dark: '#388e3c',
      light: '#81c784',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h6: {
      color: '#00239C',
      fontWeight: 'bold',
    },
    subtitle1: {
      color: '#00239C',
      fontWeight: 'bold',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': {
          fontFamily: 'Roboto',
          src: `url(${roboto})`,
          fontDisplay: 'swap',
        },
        '.grecaptcha-badge': {
          visibility: 'hidden !important',
        },
      },
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        margin: 0,
      },
    },
    MuiPickersDay: {
      day: {
        margin: '2px 0',
      },
    },
  },
});

export default theme;
